import { setupI18n } from '@lingui/core';
import { messages as messages$3 } from '../locales/en/messages.js';
import { messages as messages$1 } from '../locales/es/messages.js';
import { messages as messages$2 } from '../locales/pt-br/messages.js';

const messages = {
  en: messages$3,
  "pt-br": messages$2,
  es: messages$1
};
const i18n = setupI18n({
  locale: "pt-br",
  locales: ["pt-br", "es", "en"],
  messages
});

export { i18n };
